module.exports = __webpack_public_path__ + "static/media/v2-explora-kargoetag.42023190.jpg";